



























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const filter = namespace('filter');

const sortOptions = [
  {
    key: 'name',
    direction: 'asc',
    public: 'Slide Name from A'
  },
  {
    key: 'name',
    direction: 'desc',
    public: 'Slide Name from Z'
  },
  {
    key: 'createdAt',
    direction: 'desc',
    public: 'Newest creation date'
  },
  {
    key: 'createdAt',
    direction: 'asc',
    public: 'Oldest creation date'
  },
  {
    key: 'updatedAt',
    direction: 'desc',
    public: 'Last updated'
  }
];

@Component({
  components: {}
})
export default class SortLibComponent extends Vue {
  private sortOptions: any[] = sortOptions;
  private currentSortIndex: number = 4;

  private currentSort: any = sortOptions[this.currentSortIndex];

  changeSort(option: any, index: number) {
    this.currentSortIndex = index;
    this.currentSort = option;
    this.setSort(option);
  }

  mounted() {
    const sortStorageItem = localStorage.getItem('sort');
    if (sortStorageItem) {
      try {
        const option = JSON.parse(sortStorageItem);
        this.currentSort = option;
      } catch (error) {}
    }
  }

  @filter.Mutation('setSortItem') setSort!: (a: { key: string; direction: 'desc' | 'asc' }) => void;
}
